import { api } from "lib";

export const getAdminDetails = async (params = {}) => {
    return await api.post("/v1/admin/getAdminDetailsFromToken", params);
};